module.exports = __webpack_public_path__ + "static/media/callchat-new.c423fb3c.svg";